import { MatrixDialogComponent } from './matrix-dialog/matrix-dialog.component';
import { AngularFireDatabase } from 'angularfire2/database';
import { Component, Inject } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent { }



// WEBPACK FOOTER //
// ./src/app/app.component.ts